module.exports = __webpack_public_path__ + "img/icfa-image-generale.a7e3eec.jpg";